module.exports = __webpack_public_path__ + "img/nybt.12b03b82.png";